<div class="chart-container">
    <canvas
    baseChart
    [datasets]="chartData"
    [labels]="dateFormatLabels"
    [options]="barChartOptions"
    [legend]="chartLegend"
    [type]="chartType"
    (chartHover)="chartHovered($event)"
    (chartClick)="chartClicked($event)"
  >
  </canvas>
  <!--  [colors]="colorArray" -->
    <div id="ccr-cce-chart-tooltip">
        <div>
            <div>{{tooltipLabel}}</div>
            <div><span class="chart-legend-color-box"></span> {{tooltipDataSetName}} : {{tooltipDataValue}}</div>
        </div>
    </div>

</div>
